var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert",class:_vm.message.type},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-hidden":"true"},on:{"click":function($event){return _vm.hideAlert()}}},[_vm._v(" × ")]),_c('ul',{staticClass:"ul-block"},[_c('li',[_vm._v(_vm._s(_vm.message.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }